import { Component } from 'react';
import { DATA } from './configs';

class Information extends Component {
    constructor(props) {
        super(props);

        this.onChangeActiveMenu = this.onChangeActiveMenu.bind(this);
        this.getLogo = this.getLogo.bind(this);

        this.state = {
            activeMenu: props.isFreeAiTemplate ? 'ai_analytics' : 'google_discover_analytics',
        };
    }

    onChangeActiveMenu(menu) {
        this.setState({ activeMenu: menu });
    }

    getLogo() {
        switch (this.state.activeMenu) {
            case 'ai_analytics':
                return '/static/img/ai_icon.svg';
            case 'google_discover_analytics':
                return '/static/img/google_discover.svg';
            case 'search_analytics':
                return '/static/img/google-icon.png';
            case 'commerce':
                return '/static/img/google_icon_2.svg';
            default:
                return '';
        }
    }

    render() {
        return (
            <div className="custom-registration-body-step">
                <div className="custom-registration-information">
                    <div className="custom-registration-information-header">
                        Turn Your Content into a <span className="ml-10">Traffic Magnet</span>
                    </div>
                    <div className="d-flex justify-content-center w-100">
                        <div className="custom-registration-information-subheader">
                            <span>GDdash</span> uses Google’s technology to analyze your content and
                            reveal <br /> your authoritative entities, helping you maximize traffic
                            effortlessly.
                        </div>
                    </div>
                    <div className="custom-registration-information-menu">
                        <div
                            className={`custom-registration-information-menu-item ${
                                this.state.activeMenu === 'ai_analytics' ? 'active' : ''
                            }`}
                            onClick={() => this.onChangeActiveMenu('ai_analytics')}
                        >
                            <div className="custom-registration-information-menu-item-img">
                                <img src="/static/img/ai_icon.svg" />
                            </div>
                            AI Analytics
                        </div>
                        {!this.props.isFreeAiTemplate && (
                            <>
                                <div
                                    className={`custom-registration-information-menu-item ${
                                        this.state.activeMenu === 'google_discover_analytics'
                                            ? 'active'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        this.onChangeActiveMenu('google_discover_analytics')
                                    }
                                >
                                    <div className="custom-registration-information-menu-item-img">
                                        <img src="/static/img/google_discover.svg" />
                                    </div>
                                    Discover Analytics
                                </div>
                                <div
                                    className={`custom-registration-information-menu-item ${
                                        this.state.activeMenu === 'search_analytics' ? 'active' : ''
                                    }`}
                                    onClick={() => this.onChangeActiveMenu('search_analytics')}
                                >
                                    <div className="custom-registration-information-menu-item-img">
                                        <img src="/static/img/google-icon.png" />
                                    </div>
                                    Search Analytics
                                </div>
                                <div
                                    className={`custom-registration-information-menu-item ${
                                        this.state.activeMenu === 'commerce' ? 'active' : ''
                                    }`}
                                    onClick={() => this.onChangeActiveMenu('commerce')}
                                >
                                    <div className="custom-registration-information-menu-item-img">
                                        <img src="/static/img/google_icon_2.svg" />
                                    </div>
                                    Commerce
                                </div>
                            </>
                        )}
                    </div>
                    <div className="custom-tooltip-content">
                        <div className="custom-tooltip-content-products">
                            {DATA.find(
                                (item) => item.category === this.state.activeMenu,
                            ).features.map((item) => (
                                <div
                                    key={item.title}
                                    className="custom-tooltip-content-products-item custom-max-width"
                                >
                                    <div className="custom-tooltip-content-products-item-img">
                                        <img src={this.getLogo()} />
                                    </div>
                                    <div className="custom-tooltip-content-products-item-content">
                                        <div className="header">{item.title}</div>
                                        <div className="description">{item.description}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Information;
